import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AvailableModals, closeModal } from '../modalSlice';
import { ReduxState, useAppDispatch } from '../../../store';
import { Modal } from 'antd';
import { useGetSkuQuery } from '../../Detail/apiDetail';
import PickingLineProductGroupInfo from '../../CalculationDetail/Redistribution/parts/listing/components/SkuDetailSection/PickingLineProductGroupInfo/PickingLineProductGroupInfo';

const modalId = AvailableModals.PICKING_LINE_PRODUCT_GROUPS;

const PickingLineProductGroupsModal: React.FC = () => {
  const dispatch = useAppDispatch();

  const open = useSelector((state: ReduxState) => state.modal.openedModal === modalId);
  const modalData = useSelector((state: ReduxState) => state.modal.modalData[modalId]);
  const { sourceSkuId } = modalData ?? { sourceSkuId: 0, targetSkuId: 0 };

  const { isFetching: isSkuFetching } = useGetSkuQuery(sourceSkuId);

  const handleClose = useCallback(() => {
    dispatch(closeModal());
  }, [dispatch]);

  const title = isSkuFetching ? 'Loading...' : null;

  if (!open) return null;
  return (
    <Modal title={title} centered open={true} width="80%" onCancel={handleClose} footer={null}>
      <PickingLineProductGroupInfo />
    </Modal>
  );
};

export default PickingLineProductGroupsModal;
